import { css } from 'emotion';

import { colors } from '../styles';

export const container = css`
  border: 1px solid ${colors.gray.light};
  border-radius: 5px;
  box-shadow: none;
`;

export const summary = css`
  padding: 20px;
`;

export const summaryHeader = css`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;

export const openCloseIcon = css`
  color: ${colors.gray.dark};
`;
